import { hyphen } from "../../../../Shared/utils/hyphenate"
import { Pager } from "../../../components/pager"
import { library } from "../../../libraries"
import { renderContents } from "../../components/jumbo"
import { Link } from "../../components/library/link"
import { SearchBar } from "../searchBar/searchBarLayout"
import { emptySearchResult } from "../searchPage/searchPageState"
import { SearchPageLayoutProps } from "./searchPageState"
import React = require("react")

const displayBundle = (bundle: string): string => {
  if (bundle == "activity") return "Activiteit"
  if (bundle == "faq") return "FAQ"
  if (bundle == "location_detail") return "Vestiging"
  if (bundle == "vacancy") return "Vacature"
  if (bundle == "sections") return "Sectie"
  if (bundle == "collection_overview") return "Collectieoverzicht"
  if (bundle == "report") return "Terugblik"
  if (bundle == "blog_post") return "Blog"
  if (bundle == "news_item") return "Nieuws"
  return "Pagina"
}

export const SearchPageLayout = (props: SearchPageLayoutProps) => {
  const { searchQuery, searchResults, currentPage, pageSize, updatePage, updateQuery, runQuery } = props
  const { totalResults, results, query: currentQuery, page: resultPage } = searchResults.kind == 'loaded' ? searchResults.value : emptySearchResult

  const pager = totalResults
    ? Pager({ currentPage, pageSize, totalResults, setPage: (page) => updatePage(page) })
    : <></>

  return (
    <React.Fragment key="search-page">
      <header className="jumbotron jumbotron--small jumbotron--search">
        <div className="jumbotron__outer">
          <div className="jumbotron__inner container--mg align--center">
            <div className="jumbotron__content">
              <div className="form form--search search--pageheader">
                <h1 className="sr-text">Zoeken</h1>
                <label htmlFor="collection-search" className="form__label search__label title--xl">Zoek in de site</label>
                <div className="search__input-container form__item--icon left">
                  <SearchBar id="site-search-page" query={searchQuery} updateSearchQuery={(newQuery) => updateQuery(newQuery)} runSearchQuery={() => runQuery()} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className={`search-results align--center search-results--${searchResults.kind}`}>
        <div className="search-results__inner">
          {results.length == 0
            ? <h2 className="search-results__title title--s">{`Niets gevonden`}</h2>
            : <>
              <h2 className="search-results__title title--s">{`${totalResults} ${totalResults == 1 ? "resultaat" : "resultaten"} ${currentQuery == "" ? "" : `voor \"${currentQuery}\"`}`}</h2>
              <ul className="teasers row">
                {results.map((result, index) =>
                  <li className={`teaser teaser--search teaser--image ${result.ImageUrls['400x280'] ? 'has-image' : 'has-placeholder'} col-xs-12`} key={`${currentQuery}-${resultPage}-${index}`}>
                    <Link url={result.Url ? result.Url : ""} className="teaser__link">
                      <article className="teaser__inner has-label">
                        <div className="teaser__content">
                          <div className="teaser__meta">
                            <div className="teaser__label">{displayBundle(result.Bundle)}</div>
                          </div>

                          <div className="teaser__content-inner">
                            <header className="teaser__header">
                              <h3 className="teaser__title">
                                <span>{hyphen(result.Title)}</span>
                              </h3>
                            </header>

                            {result.Description && (
                              <div className="teaser__text">
                                <div className="teaser__intro">{renderContents(result.Description, <div />, <div />)}</div>
                              </div>
                            )}
                          </div>
                        </div>
                        {result.ImageUrls['400x280'] ?
                            <div className="teaser__visual" aria-hidden="true">
                              <img
                                src="/bkw/images/bkw/empty.png"
                                data-src={result.ImageUrls['400x280']}
                                data-srcset={result.ImageUrls['800x560'] ? `${result.ImageUrls['400x280']} 400w, ${result.ImageUrls['800x560']} 800w` : undefined}
                                alt={result.ImageAlt ? result.ImageAlt : ''}
                                width="200"
                                height="140"
                                className="teaser__image lazyload"
                              />

                            </div>

                            : <div className="teaser__placeholder" aria-hidden="true">
                              <img {...library().searchPlaceholderImage}
                                className="teaser__image teaser__image--placeholder lazyload"
                              />
                            </div>}
                      </article>
                    </Link>
                  </li>
                )}
              </ul>
            </>
          }

        </div>
      </section>

      {pager}

    </React.Fragment>
  )
}

